import { api } from './api';

export interface ISignature {
  signerName: string;
  signerCpf?: string;
  signerRole?: string;
  certificateType: 'govbr_prata' | 'govbr_ouro' | 'icp_brasil_a1' | 'icp_brasil_a3' | 'eletronica';
  hashSha256?: string;
  signedAt: string;
  authCode?: string;
  ipAddress?: string;
  isValid: boolean;
}

export interface ISignaturesResponse {
  documentId: string;
  documentName: string;
  documentPages?: number;
  size?: number;
  signatures: ISignature[];
  totalSignatures: number;
  hasValidSignatures: boolean;
}

export interface ISignPayload {
  signerName: string;
  signerCpf?: string;
  signerRole?: string;
  certificateLevel?: 'govbr_prata' | 'govbr_ouro';
  certificateType?: 'icp_brasil_a1' | 'icp_brasil_a3';
}

export const signaturesService = {
  async signGovBr(documentId: string, payload: ISignPayload, file?: File) {
    if (file) {
      const formData = new FormData();
      formData.append('document', file);
      formData.append('signerName', payload.signerName);
      if (payload.signerCpf) formData.append('signerCpf', payload.signerCpf);
      if (payload.signerRole) formData.append('signerRole', payload.signerRole);
      if (payload.certificateLevel) formData.append('certificateLevel', payload.certificateLevel);

      const response = await api.post(`/signatures/documents/${documentId}/govbr`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    } else {
      const response = await api.post(`/signatures/documents/${documentId}/govbr`, payload);
      return response.data;
    }
  },

  async signIcpBrasil(documentId: string, payload: ISignPayload, file?: File) {
    if (file) {
      const formData = new FormData();
      formData.append('document', file);
      formData.append('signerName', payload.signerName);
      if (payload.signerCpf) formData.append('signerCpf', payload.signerCpf);
      if (payload.signerRole) formData.append('signerRole', payload.signerRole);
      if (payload.certificateType) formData.append('certificateType', payload.certificateType);

      const response = await api.post(`/signatures/documents/${documentId}/icpbrasil`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    } else {
      const response = await api.post(`/signatures/documents/${documentId}/icpbrasil`, payload);
      return response.data;
    }
  },

  async getSignatures(documentId: string): Promise<ISignaturesResponse> {
    const response = await api.get(`/signatures/documents/${documentId}`);
    return response.data;
  },

  async verifyAuthCode(authCode: string) {
    const response = await api.get(`/signatures/verify/${authCode}`);
    return response.data;
  },
};
